module.exports = __webpack_public_path__ + "img/bg_njtgxc_tit.13395988.png";